import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./PinLevelPermissionCheckbox.module.css";

/**
 * Interactive component. A styled checkbox that allows the user to toggle a pin level permission.
 */
export function PinLevelPermissionCheckbox({
  pinLevelType, // e.g., "PLA"
  label, // e.g., "Platinum"
  setCheckedPermissions,
  isChecked,
}) {
  const handleOnChange = () => {
    setCheckedPermissions(pinLevelType);
  };

  return (
    <div className={styles.container}>
      <label htmlFor={pinLevelType}>
        {/* <input
          type="checkbox"
          checked={isChecked}
          hidden
          name={pinLevelType}
          value={pinLevelType}
          onChange={handleOnChange}
        /> */}

        <span
          style={{
            backgroundColor:
              label === "AssociateIbo" // Update to use label
                ? "#fff"
                : label === "Platinum" // Update to use label
                ? "#e5eeef"
                : label === "Emerald" // Update to use label
                ? "#bbd2d5"
                : "#91b6bb",
          }}
          className={classNames(styles.checkbox, {
            [styles.inactive]: !isChecked,
          })}
          onClick={() => setCheckedPermissions(pinLevelType)}
        >
          {label === "AssociateIbo" // Update to use label
            ? "IBO"
            : label === "Platinum" // Update to use label
            ? "PLA"
            : label === "Emerald" // Update to use label
            ? "EM"
            : "DIA"}
        </span>
      </label>
    </div>
  );
}

PinLevelPermissionCheckbox.propTypes = {
  /**
   * String that determines the type (text & color) of the badge.
   */
  pinLevelType: PropTypes.oneOf(["IBO", "PLA", "EM", "DIA"]),
  /**
   * Update to include new label type
   */
  label: PropTypes.oneOf(["AssociateIbo", "Platinum", "Emerald", "Diamond"]),
  /**
   * Function that fires onClick.
   * Pass the event.target.textContent as the parameter.
   */
  setCheckedPermissions: PropTypes.func,
  /**
   * Boolean that determines whether the checkbox is checked or not.
   */
  isChecked: PropTypes.bool,
};
